import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Mousewheel, Navigation, Pagination } from 'swiper/modules';
import styles from './Css/PopularAuthor.module.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { useAuthors } from '../../../hooks/useAuthors';

function PopularAuthor() {
  const navigate = useNavigate();
  const { authors, isLoading, error } = useAuthors();
  


  const handleAuthorClick = (author) => {
    navigate(`/author/${author.id}`);
  };

  if (isLoading) {
    return <div className={styles.loading}>Loading authors...</div>;
  }

  if (error) {
    return <div className={styles.error}>Failed to load authors</div>;
  }

  return (
    <div className={styles.containerMain}>
      <div className={styles.container}>
        <div className={styles.author}>
          <h2 className={styles.heading}>Popular Author</h2>
          <Swiper
            modules={[Navigation, Pagination, Mousewheel]}
            spaceBetween={20}
            navigation
            mousewheel={{
              forceToAxis: true,
              invert: false,
              sensitivity: 1,
            }}
            pagination={{ clickable: true }}
            breakpoints={{
              320: {
                slidesPerView: 2,
                spaceBetween: 10,
              },
              480: {
                slidesPerView: 2,
                spaceBetween: 15,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 20,
              },
              1200: {
                slidesPerView: 5,
                spaceBetween: 20,
              },
            }}
            className={styles.swiper}
          >
            {authors?.map((author) => (
              <SwiperSlide key={author.id} className={styles.swiperSlide}>
                <div
                  className={styles.authorCard}
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleAuthorClick(author)}
                >
                  <div className={styles.imageWrapper}>
                    <img
                      src={author.profile_image                      }
                      alt={author.name}
                      className={styles.authorImage}
                    />
                  </div>
                  <h3 className={styles.authorName}>{author.name}</h3>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
}

export default PopularAuthor;